import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import CommonForm from "Components/Common/CommonForm";
import { AliquotFormValues } from "../helper/aliquote.types";
import { aliquotFields } from "../helper/aliquoteconstant";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface Props {
  isOpen: boolean;
  existingData: AliquotFormValues | null;
  onSave: (data: AliquotFormValues) => void;
  onCancel: () => void;
  title?: string;
  isLoading?: boolean;
}

const AddEditAliquot: React.FC<Props> = ({
  isOpen,
  existingData,
  onSave,
  onCancel,
  title,
  isLoading,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<AliquotFormValues>({
    defaultValues: {
      aliquot_sort: "",
      aliquot_number: "",
    },
    mode: "onChange"
  });

  useEffect(() => {
    if (existingData) {
      reset({
        aliquot_sort: existingData.aliquot_sort,
        aliquot_number: existingData.aliquot_number,
      });
    } else {
      reset({ aliquot_sort: "", aliquot_number: "" });
    }
  }, [existingData, reset, isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      size="md"
      centered
      className="common_modal"
    >
      <ModalHeader toggle={onCancel} className="p-3">
        {title || (existingData ? "Edit Aliquot" : "Add Aliquot")}
      </ModalHeader>
      <ModalBody>
        <form id="aliquotForm" onSubmit={handleSubmit(onSave)}>
          <CommonForm
            columns={1}
            control={control}
            errors={errors}
            fields={aliquotFields}
            setValue={setValue}
          />
        </form>
      </ModalBody>
      <ModalFooter className="bg-white border-top">
        <Button outline onClick={onCancel} type="button">
          Cancel
        </Button>
        <Button
          color="primary"
          type="submit"
          form="aliquotForm"
          disabled={isLoading}
          outline
        >
          {isLoading && (
            <span className="spinner-border spinner-border-sm me-2" />
          )}
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditAliquot;
